export const isValueExists = value => {
    return value !== undefined && value !== null;
};